export const MAX_NUMBER_OF_MESSAGES_PER_REQUEST = 10;

export const GET_FEED_MESSAGES_QUERY_KEY = ['feedMessages'] as const;
